/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-04-08 00:44:17
 *
 *******************************************************/
// @flow

import { UPDATE_EXECUTION_ID } from 'stores/flow-type/analytics-query-execution-id.type';

/**
 * call to update manual values for multi level tags
 */

export const updateExecutionId = data => {
  return {
    type: UPDATE_EXECUTION_ID,

    payload: { data }
  };
};
